<h1 mat-dialog-title>Kies je interactie</h1>

<mat-dialog-content class="flex! flex-col">
  <div class="flex items-center gap-2">
    @if (canReadTags()) {
      <app-tag-filter
        class="block max-w-45"
        panelWidth="280px"
        [tags]="filterTags()"
        [selectedTagIds]="selectedTagIds()"
        (selectedTagIdsChange)="handleTagFilterChange($event)"
        [class.highlight-flash]="restoredTags()"
      />
    }

    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
      [class.highlight-flash]="restoredSearch()"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        cdkFocusInitial
        placeholder="Zoeken op naam..."
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  @if (selectedTagIds().length) {
    <div class="flex flex-wrap gap-1 mt-2">
      @for (tag of selectedTags(); track tag.id) {
        <div class="inline-flex items-center gap-1 bg-gray-300 text-gray-800 py-1 pl-2 rounded-full text-xs font-medium">
          <span>{{ tag.label }}</span>
          <button mat-icon-button class="p-0! inline-flex! items-center! justify-center! mr-1 size-5! hover:text-gray-800!" (click)="removeTag(tag.id)">
            <mat-icon class="text-base! size-4! leading-none! font-medium!">cancel</mat-icon>
          </button>
        </div>
      }
    </div>
  }

  <div class="pt-6 pb-2 text-sm font-medium">
    @if (maxSelectionLimit(); as limit) {
      {{ selectedIds().size }} van {{ limit }} interactie(s)
      geselecteerd
    } @else {
      {{ selectedIds().size }} interactie(s) geselecteerd
    }
  </div>

  <div class="-mx-6 py-2 border-y border-gray-200 overflow-auto scrollbar-width-thin">
    <div class="flex flex-col gap-8 min-h-70">
      <div class="px-6">
        <div class="flex items-center justify-between pt-2 pb-4">
          <div class="text-sm font-medium">Interacties</div>
          @if (allowCreate) {
            <a
              [href]="createInteractionHref"
              (click)="handleCreateInteraction($event)"
              [class.pointer-events-none]="creating() || submitted()"
              [class.opacity-50]="creating() || submitted()"
              class="text-xs font-medium text-blue-700 hover:text-blue-900 flex items-center gap-1"
              tabindex="-1"
            >
              <span>Interactie aanmaken</span>
            </a>
          }
        </div>

        <mat-selection-list class="p-0!" [multiple]="multiple" [disabled]="submitted()" (selectionChange)="handleSelectionChange($event)">
          @for (item of dataSource(); track item._id) {
            <mat-list-option
              #x
              togglePosition="before"
              [value]="item"
              [selected]="selectedIds().has(item._id)"
              [disabled]="isItemDisabled(item)"
              class="pl-2! select-none [--mdc-list-list-item-disabled-state-layer-color:transparent] [--mdc-list-list-item-hover-state-layer-color:var(--color-gray-200)] [--mdc-list-list-item-hover-state-layer-opacity:1] [--mdc-list-list-item-container-shape:var(--radius-lg)]"
            >
              <div class="grid grid-cols-[1fr_auto_auto_auto_auto] gap-4 items-center">
                <div class="min-w-0">
                  <div class="text-sm truncate" [matTooltip]="item.label" matTooltipPosition="after">
                    {{ item.label }}
                  </div>
                </div>
                <div>
                  @if (item.clientId === null) {
                    <span
                      class="bg-blue-100 text-blue-800 py-0.5 px-1.5 rounded-full text-[10px] font-medium whitespace-nowrap"
                    >
                      Template
                    </span>
                  }
                </div>
                <div>
                  <span
                    class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
                  >
                    v{{ item.version }}
                  </span>
                </div>
                <div class="text-xs text-gray-500">
                  {{ item.estimatedDuration | secondsToDuration }}
                </div>
                <div>
                  <button
                    mat-icon-button
                    matTooltip="Bekijk flow"
                    type="button"
                    (click)="openFlowView($event, item)"
                  >
                    <mat-icon class="text-base!">account_tree</mat-icon>
                  </button>
                </div>
              </div>
            </mat-list-option>
          } @empty {
            <p>Er zijn geen interacties om te selecteren.</p>
          }
        </mat-selection-list>

        @if (showLoadMore()) {
          <button
            mat-button
            (click)="loadMoreItems()"
            [disabled]="fetching()"
            class="w-full [--mdc-text-button-container-shape:var(--radius-lg)]"
          >
            Meer laden
          </button>
        }
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || selectedIds().size === 0"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
